module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-27-da4946fbb6b0cac7cd9f3899c9b3ff25.png";